import { render, staticRenderFns } from "./miniStat.vue?vue&type=template&id=9ecb354e&scoped=true&"
import script from "./miniStat.vue?vue&type=script&lang=js&"
export * from "./miniStat.vue?vue&type=script&lang=js&"
import style0 from "./miniStat.vue?vue&type=style&index=0&id=9ecb354e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecb354e",
  null
  
)

export default component.exports